module.exports = __webpack_public_path__ + "static/media/445867011_984886586130828_1437598595255600298_n.2cebead6.jpg";